export const AGORA_APP_ID = '24d720d21ce748d499e936328229ac26'
